import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 23"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#333",
  "fill-rule": "evenodd",
  d: "M28.8 1.643H3.2c-.884 0-1.6.735-1.6 1.643v16.428c0 .908.716 1.643 1.6 1.643h25.6c.884 0 1.6-.735 1.6-1.643V3.286c0-.908-.716-1.643-1.6-1.643M3.2 0C1.433 0 0 1.471 0 3.286v16.428C0 21.53 1.433 23 3.2 23h25.6c1.767 0 3.2-1.471 3.2-3.286V3.286C32 1.47 30.567 0 28.8 0z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#333",
  "fill-rule": "evenodd",
  d: "M32 9.036H1.6V7.393H32zM4 16.429a.81.81 0 0 1 .8-.822H8c.442 0 .8.368.8.822a.81.81 0 0 1-.8.821H4.8a.81.81 0 0 1-.8-.821M10.4 16.429c0-.454.359-.822.8-.822h3.2c.442 0 .8.368.8.822a.81.81 0 0 1-.8.821h-3.2a.81.81 0 0 1-.8-.821",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }